import { render, staticRenderFns } from "./_themeProvider.vue?vue&type=template&id=026c1dba&lang=pug"
import script from "./_themeProvider.vue?vue&type=script&lang=js"
export * from "./_themeProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports